<template>
  <div class="addr-box">
    <div>
      <van-form :show-error-message="false" validate-trigger="onChange" @failed="failed">
        <van-cell-group inset :border="false">

          <!-- <div class="input-box" style="margin-top:20px;" @click="handleOpenSearch">
            <van-field
              :value="mapCenterInfo.detailedAddress"
              name=""
              placeholder=""
              class="input"
              disabled
            />
            <span style="font-size:12px;color:#4776E3;flex-shrink:0;padding-right:16px;">更改</span>
          </div> -->
          <div class="title-info flex-sb" @click="handleOpenSearch">
            <div style="flex: 1;overflow: hidden;">
              <div class="address-title">{{ mapCenterInfo.title }}</div>
              <div class="details-address">{{mapCenterInfo.detailedAddress}}</div>
            </div>
            <div class="update-address-btn">
              更改地址
              <i class="iconfont icon-qianjin" style="font-size: 10px;color: #C9C2BB;margin-left: 2px;"></i>
            </div>
          </div>
          <div class="input-box">
            <van-field
              v-model.trim="form.remark"
              label="详细地址"
              name="详细地址"
              placeholder="如：1栋2206"
              class="input"
              :rules="[{ validator: specialCharacterValid, message: '不支持空格及特殊符号' , trigger:'onChange' }]"
              @blur="formChange"
            />
          </div>
          <div class="input-box">
            <van-field
              v-model.trim="form.realName"
              label="联系人"
              name="姓名"
              placeholder="姓名"
              class="input"
              style="width:348px;"
              :rules="[
                { required: true, message: '请填写姓名' },
                { pattern: /^(([a-zA-Z+\.?\·?a-zA-Z+]{2,30}$)|([\u4e00-\u9fa5+\·?\u4e00-\u9fa5+]{2,30}$))/, message: '请填写正确的姓名' },
              ]"
              @blur="formChange"
            />
            <van-field
              v-model.trim="form.phoneNumber"
              name="手机/座机"
              placeholder="手机/座机"
              class="input"
              :rules="[
                { required: true, message: '请填写手机/座机' },
                { pattern: /^((0\d{2,3}-\d{7,8})|(1\d{10})|(\d{7,8}))$/, message: '请填写正确的手机/座机' },
              ]"
              @input="formChange"
            />
          </div>
        </van-cell-group>
        <div class="footer">
          <van-button 
            type="warning" 
            class="footer-cancel-button"
            @click="handleBack"
          >再等等看</van-button>
          <van-button 
            type="warning"
            class="footer-button"
            @click="submit"
            :disabled="!mapLoaded||getCenterLoading"
          >确认修改</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { Image , Field , Cell , CellGroup , Form , Button , Toast , Checkbox, CheckboxGroup  } from 'vant';
export default {
  name:'dispatch-address-info',
  props:['mapCenterInfo','openSearch','isUserType','isShowAddr','queryParams','mapLoaded','getCenterLoading','isSwitchTab','checkAddressObject'],
  components:{ 
    [Image.name]: Image,
    [Form.name]: Form,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
   },
  data(){
    return {
      form:{
        realName:'',
        phoneNumber:'',
        remark:'',
        save:''
      },
    }
  },

  watch:{
    queryParams:{
      handler(val){
        this.form = this.deepClone(val)
      },
      deep:true,
      immediate:true
    }
  },
  methods:{
    /* 特殊字符校验 */
    specialCharacterValid(val){
      return Promise.resolve(!/[`~!@#$%^&*_+=<>?:"{}|.\/;'\\[\]·~！@#￥%……&*——+={}|《》？：“”【】、；‘'。、\s]/im.test(val))
    },
    checkboxChange(value){
      this.formChange();
    },
    formChange(){
      this.$emit('update:queryParams',{
        ...this.queryParams,
        ...this.deepClone(this.form)
      })
    },
    handleOpenSearch(){
      this.$emit('update:openSearch',true);
    },
    submit(){
      this.$emit('openFixPopup',Object.assign(this.queryParams,{
        name:this.queryParams.realName,
        phone:this.queryParams.phoneNumber
      }));
    },
    failed({ errors }){
      Toast.fail(errors[0].message);
    },
    handleBack(){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped lang="scss">
  .addr-box {
      box-sizing: border-box;
      position: relative;
      z-index: 99;
      background-color: #FFEAD8;
      & > div {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        padding: 0 22px;
        background-color: #FFF;
        overflow: hidden;
      }
      * {
        color: #130A01;
      }
      .van-form {
        position: relative;
        z-index: 100000;
        .van-cell-group {
          margin: 0;
        }
        .title-info {
          overflow: hidden;
          padding: 12px 16px;
          margin: 16px 0;
          background-color: #F8F8F8;
          .details-address {
            font-size: 12px;
            line-height: 20px;
            color: #85807B;
          }
          .address-title {
            font-size: 18px;
            font-weight: bold;
            line-height: 26px;
            color: #3D3833;
          }
          .update-address-btn {
            flex-shrink: 0;
            margin-left: 13px;
            height: 24px;
            background-color: #FFF;
            border-radius: 2px;
            overflow: hidden;
            border: 1px solid #F5F1EF;
            font-size: 12px;
            line-height: 24px;
            padding: 0 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            counter-reset: #3D3833;
          }
        }
        .group-addr {
          padding: 0;
          width: auto;
          ::v-deep .van-radio__label {
            font-size: 14px;
            line-height: 30px;
          }
        }
        .input-box {
          height: 36px;
          overflow: hidden;
          background-color: #F5F5F5;
          border-radius: 6px;
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          ::v-deep .van-field__body {
            height: 100%;
          }
          .input {
            background-color: #F5F5F5;
            height: 36px;
            font-size: 16px;
          }
        }
        .footer {
          margin-bottom: 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .footer-button {
            height: 38px;
            flex: 2;
            padding: 0 24px;
            background: #EC892E;
            border-radius: 4px;
            font-size: 16px;
            user-select: none;
            line-height: 38px;
            .van-button__text {
              font-family: 'DIN-Medium';
              color: #FFF;
            }
          }
          .footer-cancel-button {
            height: 38px;
            flex: 1;
            border: 1px solid #EC892E;
            background-color: #ffffff;
            margin-right: 16px;
            .van-button__text {
              font-family: 'DIN-Medium';
              color:#EC892E;
            }
          }
        }
      }
    }
    ::v-deep .van-field {
      align-items: center;
      .van-field__label {
        width: auto;
        font-size: 16px;
        line-height: 24px;
        display: flex;
        align-items: center;
        color: #1E1E1E;
      }
      .van-field__value {
        font-size: 16px;
        line-height: 24px;
      }
    }
  ::v-deep .van-hairline--top-bottom {
    &:after {
      border: none;
    }
  }
  ::v-deep .van-checkbox {
    .van-checkbox__label {
      font-size: 13px;
      color: #130A01;
    }
  }
  ::v-deep .van-field__control:disabled {
    color: #333 !important;
    -webkit-text-fill-color:#333 !important;
  }
</style>